<div id="appCapsule">  
    <div class="text-center">
        <div class=""><img src="assets/img/error-404.png" alt="error-404" width="200" />  </div>
        <div class="mt-5"><button class="btn btn-primary mr-2" (click)="goHome()">Go back Home</button></div>
    </div>    
</div>